<script>
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import { UserGroupIcon } from '@heroicons/vue/24/outline'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'


export default {
  name: "TeamCompact",
  components: { TwBadge, TwProgressBar, UserGroupIcon },
  props: {
    team: {
      type:Object,
      required:true
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.team.fundraiser_id)
    }
  }
}
</script>

<template>
  <div class="flex gap-3 md:gap-5">
    <router-link class="cursor-pointer min-w-16" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: team.fundraiser_id, teamId: team.id }}">
      <img v-if="team.cached.cover_image_url" class="size-16 rounded-full object-cover border-2" :src="team.cached.cover_image_url" :alt="team.name">
      <span v-else class="inline-flex size-16 items-center justify-center rounded-full bg-gray-200">
        <span v-if="team.cached.owner_initials" class="font-sans text-1xl font-normal leading-none text-gray-400">{{ team.cached.owner_initials }} </span>
      </span>
    </router-link>
    <div class="flex flex-col gap-1 grow">
      <router-link class="cursor-pointer" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: team.fundraiser_id, teamId: team.id }}">
        <h6 class="hover:underline">
          {{ team.name }}
        </h6>
      </router-link>
      <div class="font-sans text-sm">
        <span v-if="team.cached" class="font-semibold">{{ team.cached.raised_formatted }}</span> raised of ${{ team.goal_formatted }} goal
      </div>
      <tw-progress-bar v-if="team.cached" size="sm" class="my-2" :progress="team.cached.percentage_raised" />
      <span>
        <tw-badge v-if="team.cached && team.cached.team_name" size="xs" class="my-2 bg-gray-200">
          <UserGroupIcon class="h-4 w-4" /> <router-link v-if="team.belongs_to_team_id" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: team.fundraiser_id, teamId: team.id }}" class="ml-1 font-semibold hover:underline">
            {{ team.cached.team_name }}
          </router-link>
          <span v-else class="font-semibold">
            {{ team.cached.team_name }}
          </span>
        </tw-badge>
      </span>
    </div>
  </div>
</template>

<style scoped>

</style>
